// TripBadgeTablePDF.js

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import logo from "./logoo.png";

// ==================================================
// STYLES (MATCHED WITH PAYMENT HISTORY STYLE)
// ==================================================
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
  },

  header: {
    borderBottom: "2 solid #0f172a",
    marginBottom: 15,
    paddingBottom: 10,
    flexDirection: "row",
    alignItems: "center",
  },

  logo: {
    width: 60,
    height: 60,
    marginRight: 10,
  },

  headerText: {
    flex: 1,
  },

  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#E11D48",
  },

  subtitle: {
    fontSize: 10,
    color: "#555",
    marginTop: 2,
  },

  table: {
    marginTop: 10,
    border: "1 solid #ddd",
  },

  row: {
    flexDirection: "row",
    borderBottom: "1 solid #eee",
    padding: 6,
  },

  head: {
    backgroundColor: "#111827",
    color: "#fff",
    fontWeight: "bold",
  },

  col: {
    flex: 1,
    fontSize: 9,
  },

  red: {
    color: "#DC2626",
  },

  green: {
    color: "#16A34A",
  },

  footer: {
    marginTop: 15,
    textAlign: "center",
    fontSize: 9,
    color: "#666",
  },
});

// ==================================================
// COMPONENT
// ==================================================
const TripBadgeTablePDF = ({
  shipments = [],
  tripName = "",
}) => {
  const totalCharge = shipments.reduce(
    (sum, s) => sum + Number(s.amount_charge || 0),
    0
  );

  const totalPaid = shipments.reduce(
    (sum, s) => sum + Number(s.amount_paid || 0),
    0
  );

  const totalBalance = shipments.reduce(
    (sum, s) => sum + Number(s.balance || 0),
    0
  );

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        
        {/* ================= HEADER ================= */}
        <View style={styles.header}>
          <Image src={logo} style={styles.logo} />

          <View style={styles.headerText}>
            <Text style={styles.title}>
              Zuluwhiskey Shipping
            </Text>

            <Text style={styles.subtitle}>
              Trip Shipment Report
            </Text>

            <Text style={styles.subtitle}>
              Trip: {tripName}
            </Text>
          </View>
        </View>

        {/* ================= TABLE HEADER ================= */}
        <View style={[styles.row, styles.head]}>
          <Text style={styles.col}>Customer</Text>
          <Text style={styles.col}>Trip</Text>
          <Text style={styles.col}>Receiver</Text>
          <Text style={styles.col}>Charge</Text>
          <Text style={styles.col}>Paid</Text>
          <Text style={styles.col}>Balance</Text>
        </View>

        {/* ================= TABLE ROWS ================= */}
        {shipments.map((item, index) => (
          <View style={styles.row} key={index}>
            <Text style={styles.col}>
              {item.customer_name || "N/A"}
            </Text>

            <Text style={styles.col}>
              {tripName || "N/A"}
            </Text>

            <Text style={styles.col}>
              {item.receiver_name || "N/A"}
            </Text>

            <Text style={styles.col}>
              ${Number(item.amount_charge || 0).toFixed(2)}
            </Text>

            <Text style={[styles.col, styles.green]}>
              ${Number(item.amount_paid || 0).toFixed(2)}
            </Text>

            <Text style={[styles.col, styles.red]}>
              ${Number(item.balance || 0).toFixed(2)}
            </Text>
          </View>
        ))}

        {/* ================= TOTAL SUMMARY ================= */}
        <View style={{ marginTop: 15, padding: 10, border: "1 solid #111827" }}>
          <Text style={{ fontWeight: "bold" }}>
            Total Charge: ${totalCharge.toFixed(2)}
          </Text>

          <Text style={styles.green}>
            Total Paid: ${totalPaid.toFixed(2)}
          </Text>

          <Text style={styles.red}>
            Total Balance: ${totalBalance.toFixed(2)}
          </Text>
        </View>

        {/* ================= FOOTER ================= */}
        <Text style={styles.footer}>
          Zuluwhiskey Shipping Management System
        </Text>

      </Page>
    </Document>
  );
};

export default TripBadgeTablePDF;



// // TripBadgeTablePDF.js

// import React from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
// } from "@react-pdf/renderer";

// // ==================================================
// // STYLES
// // ==================================================
// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     padding: 20,
//     fontSize: 9,
//   },

//   title: {
//     fontSize: 14,
//     fontWeight: "bold",
//     marginBottom: 10,
//     textAlign: "center",
//     textTransform: "uppercase",
//   },

//   subtitle: {
//     fontSize: 10,
//     marginBottom: 10,
//     textAlign: "center",
//     color: "#444",
//   },

//   table: {
//     display: "table",
//     width: "auto",
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderColor: "#000",
//   },

//   tableRow: {
//     flexDirection: "row",
//   },

//   headerRow: {
//     backgroundColor: "#000",
//     color: "#fff",
//   },

//   tableColHeader: {
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     fontSize: 8,
//   },

//   tableCol: {
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderColor: "#000",
//     padding: 5,
//     fontSize: 8,
//   },

//   colCustomer: { width: "18%" },
//   colTrip: { width: "18%" },
//   colReceiver: { width: "18%" },
//   colCharge: { width: "14%" },
//   colPaid: { width: "14%" },
//   colBalance: { width: "18%" },

//   footer: {
//     marginTop: 10,
//     fontSize: 8,
//     textAlign: "center",
//     color: "#666",
//   },
// });

// // ==================================================
// // COMPONENT
// // ==================================================
// const TripBadgeTablePDF = ({
//   shipments = [],
//   tripName = "",
// }) => {
//   return (
//     <Document>
//       <Page size="A4" orientation="landscape" style={styles.page}>
//         {/* ================= HEADER ================= */}
//         <Text style={styles.title}>
//           Trip Shipment Report
//         </Text>

//         <Text style={styles.subtitle}>
//           Trip: {tripName}
//         </Text>

//         {/* ================= TABLE ================= */}
//         <View style={styles.table}>
//           {/* HEADER ROW */}
//           <View style={[styles.tableRow, styles.headerRow]}>
//             <Text style={[styles.tableColHeader, styles.colCustomer]}>
//               Customer
//             </Text>
//             <Text style={[styles.tableColHeader, styles.colTrip]}>
//               Trip
//             </Text>
//             <Text style={[styles.tableColHeader, styles.colReceiver]}>
//               Receiver
//             </Text>
//             <Text style={[styles.tableColHeader, styles.colCharge]}>
//               Charge
//             </Text>
//             <Text style={[styles.tableColHeader, styles.colPaid]}>
//               Paid
//             </Text>
//             <Text style={[styles.tableColHeader, styles.colBalance]}>
//               Balance
//             </Text>
//           </View>

//           {/* DATA ROWS */}
//           {shipments.map((item, index) => (
//             <View style={styles.tableRow} key={index}>
//               <Text style={[styles.tableCol, styles.colCustomer]}>
//                 {item.customer_name || "N/A"}
//               </Text>

//               <Text style={[styles.tableCol, styles.colTrip]}>
//                 {tripName || "N/A"}
//               </Text>

//               <Text style={[styles.tableCol, styles.colReceiver]}>
//                 {item.receiver_name || "N/A"}
//               </Text>

//               <Text style={[styles.tableCol, styles.colCharge]}>
//                 {item.amount_charge || "0.00"}
//               </Text>

//               <Text style={[styles.tableCol, styles.colPaid]}>
//                 {item.amount_paid || "0.00"}
//               </Text>

//               <Text style={[styles.tableCol, styles.colBalance]}>
//                 {item.balance || "0.00"}
//               </Text>
//             </View>
//           ))}
//         </View>

//         {/* ================= FOOTER ================= */}
//         <Text style={styles.footer}>
//           Generated by Shipping Management System
//         </Text>
//       </Page>
//     </Document>
//   );
// };

// export default TripBadgeTablePDF;